import * as API from "../../api"
import * as ActionTypes from "../action-types";

/**
 * ThirdParty Library
 */
import {
    message
} from 'antd'

/**
 * Redux Action
 */
import {
    setLoadingVam,
    unsetLoadingVam
} from './style'

/**
 * Get VAM Vehicle issue
 */

export const get_vam_vehicle_issue_request = (vids) => dispatch => {

    dispatch(setLoadingVam())
    
    API
    .getBatchVAMVehicleIssue(vids)
    .then(info => {
        
        try {
            const {
                issues
            } = info

            dispatch(get_vam_vehicle_issue_success(issues))

        } catch(err) {
            console.log('err', err)
            message.error('Error in getting vam vehicle issues. Refresh page?')
        }

    }).finally(() => dispatch(unsetLoadingVam()))
}

const get_vam_vehicle_issue_success = (issues) => {
    return {
        type: ActionTypes.GET_VAM_VEHICLE_ISSUES,
        issues
    };
}

/**
 * CU VAM Vehicle Issue
 */

export const cu_vam_vehicle_issue_request = (item, callback = () => {}) => dispatch => {

    dispatch(setLoadingVam())
    
    API
    .CUVAMVehicleIssue(item)
    .then(info => {

        try {

            const {
                status,
                issue,
                msg
            } = info
    
            switch(status) {
                case 200: {
                    if(item.action === 'C'){
                        dispatch(create_vam_vehicle_issue_success(issue))
                    } else {
                        dispatch(update_vam_vehicle_issue_success(issue))
                    }
    
                    break;
                }
                case 500: {
                    throw msg
                }
                default: {
                    break;
                }
            }

            message.success(msg)

        } catch(err) {
            console.log("Error", err)
            message.error(err)
        }

    })
    .finally(() => {
        dispatch(unsetLoadingVam())
        callback()
    })

}

const create_vam_vehicle_issue_success = (issue) => {
    return {
        type: ActionTypes.ADD_VAM_VEHICLE_ISSUE,
        issue
    };
}

const update_vam_vehicle_issue_success = (issue) => {
    return {
        type: ActionTypes.EDIT_VAM_VEHICLE_ISSUE,
        issue
    };
}

export const get_comment_vam_vehicle_issue_request = (vamiid) => dispatch => {

    dispatch(setLoadingVam())
    
    API
    .getCommentVAMVehicleIssue(vamiid)
    .then(info => {
        
        try {
            const {
                comments
            } = info

            dispatch(get_comment_vam_vehicle_issue_success(comments))

        } catch(err) {
            message.error(err)
        }

    }).finally(() => dispatch(unsetLoadingVam()))
}

const get_comment_vam_vehicle_issue_success = (comments) => {
    return {
        type: ActionTypes.GET_COMMENT_VAM_VEHICLE_ISSUE,
        comments
    };
}

export const cud_comment_vam_vehicle_issue_request = (items, cb) => dispatch => {

    dispatch(setLoadingVam())
    
    API
    .cudCommentVAMVehicleIssue(items)
    .then(info => {
        
        try {
            const {
                comment
            } = info

            if(items.action === 'C'){
                dispatch(create_comment_vam_vehicle_issue_success(comment))
            } else if(items.action === 'U') {
                dispatch(update_comment_vam_vehicle_issue_success(comment))
            } else if(items.action === 'D') {
                dispatch(delete_comment_vam_vehicle_issue_success(comment.vamicid))
            }

        } catch(err) {
            message.error(err)
        }

    }).finally(() => {
        cb()
        dispatch(unsetLoadingVam())
    })
}

const create_comment_vam_vehicle_issue_success = (comment) => {
    return {
        type: ActionTypes.CREATE_COMMENT_VAM_VEHICLE_ISSUE,
        comment
    };
}

const update_comment_vam_vehicle_issue_success = (comment) => {
    return {
        type: ActionTypes.UPDATE_COMMENT_VAM_VEHICLE_ISSUE,
        comment
    };
}

const delete_comment_vam_vehicle_issue_success = (vamicid) => {
    return {
        type: ActionTypes.DELETE_COMMENT_VAM_VEHICLE_ISSUE,
        vamicid
    };
}

export const close_comment_success = () => {
    return {
      type: ActionTypes.CLOSE_COMMENT_VAM_VEHICLE_ISSUE,
    };
};
